export default {
  backgroundColor: '#FFC0CB',
}
